import { ROUTES } from '@shared/config/routes'
import coursesIcon from '../../assets/images/menu/courses.svg'
import favoritesIcon from '../../assets/images/menu/favorites.svg'
import homeIcon from '../../assets/images/menu/home.svg'
import profileIcon from '../../assets/images/menu/profile.svg'
import usefulIcon from '../../assets/images/menu/useful.svg'

export interface MenuItem {
  path: string
  label: string
  /**
   * Иконка из макета. Рисуется маской, а не `<img>`: тогда цвет берётся из
   * состояния пункта, и одна картинка работает и в активном, и в обычном виде.
   */
  icon: string
  /**
   * Ширина при высоте `ICON_HEIGHT`, пересчитанная из пропорций макета: там
   * иконки нарисованы под ячейку 116px, на телефоне ячейка вдвое уже.
   */
  width: number
  /** Наклон маскота — так он нарисован в макете. */
  rotate?: number
  /** Раздел только для подписчиков: остальным показываем с замком. */
  requiresSubscription?: boolean
}

/** Высота иконки, одинаковая у всех пунктов. */
export const ICON_HEIGHT = 30

/** Пункты нижнего меню в порядке макета. */
export const MENU_ITEMS: readonly MenuItem[] = [
  {
    path: ROUTES.FAVORITES,
    label: 'Избранное',
    icon: favoritesIcon,
    width: 24.9,
    rotate: -17.45,
  },
  {
    // Иконка временная: финальную выберут позже, пока оставлена прежняя.
    path: ROUTES.BASE,
    label: 'Библиотека',
    icon: usefulIcon,
    width: 29,
    requiresSubscription: true,
  },
  {
    path: ROUTES.HOME,
    label: 'Главная',
    icon: homeIcon,
    width: 32.9,
  },
  {
    path: ROUTES.COURSES,
    label: 'Курсы',
    icon: coursesIcon,
    width: 31,
  },
  {
    path: ROUTES.PROFILE,
    label: 'Профиль',
    icon: profileIcon,
    width: 20.1,
  },
]
